import { render, staticRenderFns } from "./comparison.vue?vue&type=template&id=c9ffac0a&scoped=true"
import script from "./comparison.vue?vue&type=script&lang=js"
export * from "./comparison.vue?vue&type=script&lang=js"
import style0 from "./comparison.vue?vue&type=style&index=0&id=c9ffac0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ffac0a",
  null
  
)

export default component.exports